module.exports = __webpack_public_path__ + "img/AllFloorPlans.eb00900e.png";